import Swal from "sweetalert2";

export type BodyTableLog = {
  fecha: string;
  xemail: string;
  iestado: string;
  xmensaje: string;
};

type LogTableProps = {
  table: BodyTableLog[];
};

function formatDateString(value: string): string {
  if (!/^\d{16}$/.test(value)) {
    throw new Error('Formato de fecha inválido');
  }

  const year = value.slice(0, 4);
  const month = value.slice(4, 6);
  const day = value.slice(6, 8);
  const hour = value.slice(8, 10);
  const minute = value.slice(10, 12);
  const second = value.slice(12, 14);
  // const millisecond = value.slice(14, 16); // opcional

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}

export const LogTable = ({ table }: LogTableProps) => {
  //const openMensaje = (value: any) => {
    //alert(value.xmensaje);
  //}; //

  const openMensaje = (html: any) => {
  Swal.fire({
    title: "Vista previa del correo",
    html: `
      <iframe
        style="width:100%; height:600px; border:none"
        srcdoc="${html.xmensaje.replace(/"/g, "&quot;")}"
      ></iframe>
    `,
    width: "900px",
    confirmButtonText: "Cerrar",
  })
}

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Fecha y hora
              </th>
              <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Correo del prestador
              </th>
              <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Estado
              </th>
              <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">
                Mensaje
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {table.map((value, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-4 py-2 text-sm text-gray-600">
                  {formatDateString(value.fecha)}
                </td>

                <td className="px-4 py-2 text-sm text-gray-600">
                  {value.xemail}
                </td>

                <td className="px-4 py-2">
                  <span
                    className={`inline-flex px-2 py-1 text-xs font-medium rounded-full
                  ${
                    value.iestado === 'E'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-yellow-100 text-yellow-700'
                  }`}
                  >
                    {value.iestado === 'E' ? 'Enviado' : 'Pendiente'}
                  </span>
                </td>

                {/* Botón centrado */}
                <td className="px-4 py-2 text-center">
                  <button
                    type="button"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium
                           text-black bg-orange-600 rounded-md
                           hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={() => openMensaje(value)}
                  >
                    Ver mensaje
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
